<template>
	<div class="container-fluid step4-mobile-container">
		<pos-mode-modal />
		<!-- steps-->
		<!-- step-4-config -->
		<div class="row mobile-config">
			<div class="config-container bg-black pos-r">
				<div v-show="isLoading" class="loading">
					<p class="front">{{ loadingText }}</p>
					<div class="overlay-bg" />
				</div>
				<!-- nav-checkout -->
				<nav
					id="navbar-checkout"
					class="navbar navbar-default bg-green m-b-0 header-clip"
				>
					<div class="container">
						<div class="navbar-header">
							<div class="main-logo clearfix">
								<a href="/" class="navbar-brand">
									<img src="/images/logos/logo-bld.png" alt="BLD">
								</a>
							</div>
						</div>
						<div class="navbar-options navbar-left">
							<ul class="nav navbar-nav">
								<li>
									<a
										href="#"
										class="btn btn-green checkout-button"
										@click.prevent="gotoStep5('top')"
									>
										Checkout
									</a>
								</li>
								<li>
									<promo-sales-timed>
										<template v-slot:originalContent>
											<p class="price text-white">
												${{ buildPrice | priceFormat }}
											</p>
										</template>
										<template>
											<p v-if="applyCase" class="price text-white">
												${{ discountPrice | priceFormat }}
											</p>
											<p v-else class="price text-white">
												${{ discountPrice | priceFormat }}
											</p>
										</template>
									</promo-sales-timed>
								</li>
							</ul>
						</div>
					</div>
					<!---->
				</nav>
				<div class="config-header">
					<div class="container p-a-0">
						<div class="user-config-opt col-xs-12 p-a-0 p-b">
							<ul v-if="!POS_MODE" class="w-full p-a-0 inline m-b-0">
								<li>
									<a
										href="#"
										data-toggle="modal"
										class="save-bld"
										@click="saveBuild()"
									>
										SAVE
									</a>
								</li>
								<li>
									<a
										href="#"
										data-toggle="modal"
										class="share-bld"
										@click="shareBuild('#share-overlay')"
									>
										SHARE
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<!-- /.nav-checkout -->
				<!-- pc-config-layoutt -->
				<div class="pc-config col-xs-12 p-x-0">
					<!-- pc-render -->
					<div class="container">
						<!-- pc-config -->
						<div class="config-details col-xs-12 p-a-0">
							<!-- selected-games -->
							<div class="fps-graphing">
								<div
									v-for="game in games"
									:key="'gamet-fps-' + game.id"
									class="fps-graphing-item"
									rel="game_10"
								>
									<img :src="game.image" class="img-responsive" />
									<div class="fps-graphing-item-fps">
										<div class="fps-text">
											{{ game.game_value }}
											<span>fps</span>
										</div>
										<div v-if="game.vsync == 1" class="vsync">V-SYNC</div>
									</div>
								</div>
								<div
									v-show="
										build.cpu &&
											build.cpu.vr_capable == 1 &&
											build.gpu &&
											build.gpu.vr_capable == 1
									"
									class="vr-ico"
									style="display: block;"
								>
									<a
										class="ico-link"
										data-toggle="modal"
										data-target="#vr-modal"
									>
										<img
											src="/images/icons/vr-ready.svg"
											alt=""
											width="35"
											class="m-t pull-left"
										>
										<img
											src="/images/icons/vr-ready-hover.svg"
											alt=""
											width="35"
											class="m-t pull-left"
										>
										<h3 class="text-orchid m-t-md pull-right">VR READY</h3>
									</a>
								</div>
								<div
									v-show="build.ram && build.ram.streaming_ready"
									class="vr-ico"
									style="display: block;"
								>
									<a
										class="ico-link ico-streaming"
										data-toggle="modal"
										data-target="#streaming-modal"
									>
										<img
											src="/images/icons/streaming-on.svg"
											alt=""
											width="35"
											class="m-t pull-left"
										>
										<img
											src="/images/icons/streaming-hover.svg"
											alt=""
											width="35"
											class="m-t pull-left"
										>
										<h3 class="text-orchid m-t-md pull-right">
											STREAM<br >READY
										</h3>
									</a>
								</div>
							</div>
							<!-- /.selected-games -->
							<!-- img-explode -->
							<div v-if="!isLoading" class="pc-img-explode">
								<div
									v-if="
										build.motherboard &&
											build.motherboard.coolers &&
											build.motherboard.coolers[build.cpuCooler.id]
									"
									class="motherboard"
								>
									<img
										:src="
											build.cpuCooler.motherboards[build.motherboard.id].image
										"
										alt="motherboard"
									>
								</div>
								<div class="kraken">
									<img
										src="/images/build-products/kraken/kraken.png"
										alt="kraken"
										style="display: none"
									>
								</div>
								<div class="power-supply">
									<img :src="build.powerSupply.render" alt="power-supply" >
								</div>
								<div class="case">
									<img :src="build.case.render" alt="case" >
								</div>
								<div class="gpu">
									<img :src="build.gpu.render" alt="gpu" >
								</div>
								<div class="rams">
									<img
										v-for="quantity in build.ram.quantity"
										:key="'render-ram-' + quantity"
										:src="build.ram.render"
									>
								</div>
								<div class="fans">
									<template v-for="fan in build.caseFans">
										<img
											v-for="quantity in fan.quantity"
											:key="'render-fans-' + quantity"
											:src="fan.render"
										>
									</template>
								</div>
								<div class="hdd">
									<img
										v-for="disk in build.hdd"
										v-show="disk.render"
										:key="'render-hdd-' + disk.id"
										:src="disk.render"
									>
								</div>
								<div class="ssd">
									<img
										v-for="disk in build.ssd"
										v-show="disk.render"
										:key="'render-ssd-' + disk.id"
										:src="disk.render"
									>
								</div>
								<div
									v-for="extra in build.extras"
									:key="'render-extra-' + extra.id"
									:class="extra.product_class"
								>
									<img v-show="extra.render" :src="extra.render" >
								</div>
								<div
									v-for="peripheral in build.peripherals"
									:key="'render-peripheral-' + peripheral.id"
									:class="peripheral.product_class"
								>
									<img v-show="peripheral.render" :src="peripheral.render" >
								</div>
								<div
									v-for="rgbs in build.rgbs"
									:key="'render-rgbs-' + rgbs.id"
									:class="rgbs.product_class"
								>
									<img v-show="rgbs.render" :src="rgbs.render" >
								</div>
							</div>
							<!-- /.img-explode -->
						</div>
						<!-- /.pc-config -->
					</div>
					<!-- pc-render -->
					<div v-if="!isLoading" class="config-checkout">
						<!-- option-panels -->
						<div class="config-tabs">
							<!-- options -->
							<div
								id="accordion"
								class="panel-group"
								role="tablist"
								aria-multiselectable="true"
							>
								<div class="panel panel-default">
									<!-- panel-body-CONFIGURE  -->
									<div
										id="collapseOne"
										:class="{
											in:
												fromStep5 &&
												[
													'case',
													'cooling',
													'motherboard',
													'gpu',
													'cpu',
													'psu',
													'ram',
													'storage'
												].includes(activeTab)
										}"
										class="panel-collapse collapse"
										role="tabpanel"
										aria-labelledby="headingOne"
									>
										<div class="panel-body">
											<!-- panel-group-for-options -->
											<div
												id="accordion2"
												class="panel-group"
												role="tablist"
												aria-multiselectable="true"
											>
												<!-- cases -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="cases"
														:class="{ in: activeTab == 'case' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="cases-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		CASE
																	</h3>
																	<div
																		:data-tab-disabled="
																			Boolean(isModuleDisabled('cases'))
																		"
																		class="product-content-wrapper"
																	>
																		<div
																			v-for="buildCase in groupedCases"
																			:key="'cases-' + buildCase[0].products_id"
																			:class="{
																				selected:
																					build['case'].products_id == buildCase[0].products_id ||
																					build['case'].products_id == (buildCase[1] && buildCase[1].products_id)
																			}"
																			class="product-data p-x"
																		>
																			<!-- thumb-n-info -->
																			<div class="product-info-content m-b">
																				<div class="about-product">
																					<ul
																						class="nav nav-tabs full select-pc-tab"
																					>
																						<li
																							:class="{
																								active:
																									build['case'].products_id == buildCase[0].products_id ||
																									build['case'].products_id != (buildCase[1] && buildCase[1].products_id),
																								disabled: isPartDisabled(
																									buildCase[0]
																								)
																							}"
																							@click="
																								showDisabledModal(
																									isPartDisabled(buildCase[0])
																								)
																							"
																						>
																							<a
																								:href="
																									'#case-' +
																										buildCase[0].products_id
																								"
																								data-toggle="tab"
																								role="tab"
																								aria-expanded="true"
																								aria-controls="case-one"
																								@click="
																									addPartToBuild(
																										'case',
																										buildCase[0]
																									)
																								"
																							>
																								<h5
																									v-if="buildCase[1]"
																									class="text-bold text-white"
																								>
																									{{ buildCase[0].title }}
																									{{
																										buildCase[0].products_id != build.case.products_id ? getTabPrice(buildCase[0], buildCase[1]) : ""
																									}}
																								</h5>
																								<h5
																									v-else
																									class="text-bold text-white"
																								>
																									{{ buildCase[0].title }}
																								</h5>
																							</a>
																						</li>
																						<li
																							v-if="buildCase[1]"
																							:class="{
																								active:
																									build['case'].products_id ==
																									buildCase[1].products_id,
																								disabled: isPartDisabled(
																									buildCase[1]
																								)
																							}"
																							@click="
																								showDisabledModal(
																									isPartDisabled(buildCase[1])
																								)
																							"
																						>
																							<a
																								:href="
																									'#case-' +
																										buildCase[1].products_id
																								"
																								data-toggle="tab"
																								role="tab"
																								aria-expanded="false"
																								aria-controls="case-two"
																								@click="
																									addPartToBuild(
																										'case',
																										buildCase[1]
																									)
																								"
																							>
																								<h5
																									class="text-bold text-white"
																								>
																									{{ buildCase[1].title }}
																									{{
																										buildCase[1].products_id != build.case.products_id ? getTabPrice(buildCase[1], buildCase[0]) : ""
																									}}
																								</h5>
																							</a>
																						</li>
																					</ul>
																				</div>
																				<div class="about-product">
																					<div class="tab-content">
																						<div
																							:id="
																								'case-' +
																									buildCase[0].products_id
																							"
																							:class="{
																								active:
																									build['case'].products_id == buildCase[0].products_id ||
																									build['case'].products_id != (buildCase[1] && buildCase[1].products_id),
																								disabled: isPartDisabled(
																									buildCase[0]
																								)
																							}"
																							class="tab-pane"
																							@click="
																								showDisabledModal(
																									isPartDisabled(buildCase[0])
																								)
																							"
																						>
																							<div
																								:class="{
																									disabled: isPartDisabled(
																										buildCase[0]
																									)
																								}"
																								class="product-image"
																							>
																								<img
																									:src="buildCase[0].image"
																									alt=""
																								>
																							</div>
																							<p class="text-white">
																								{{ buildCase[0].description }}
																							</p>
																							<!-- selection-btn -->
																							<div class="cant-select">
																								<a
																									v-if="
																										!isPartDisabled(
																											buildCase[0]
																										) &&
																											!isModuleDisabled('cases')
																									"
																									class="text-white-i"
																									:class="
																										getSelectedClass(
																											'btn btn-green btn-outline',
																											getPrice(
																												'case',
																												buildCase[0].price,
																												null,
																												buildCase[0].products_id
																											)
																										)
																									"
																									@click="
																										addPartToBuild(
																											'case',
																											buildCase[0]
																										)
																									"
																								>
																									{{
																										getPrice(
																											"case",
																											buildCase[0].price,
																											null,
																											buildCase[0].products_id
																										)
																									}}
																								</a>
																								<disabled-button
																									v-else
																									buttons-type="single"
																								/>
																							</div>
																							<!-- /.selection-btn -->
																						</div>
																						<div
																							v-if="buildCase[1]"
																							:id="
																								'case-' +
																									buildCase[1].products_id
																							"
																							:class="{
																								active:
																									build['case'].products_id ==
																									buildCase[1].products_id,
																								disabled: isPartDisabled(
																									buildCase[1]
																								)
																							}"
																							class="tab-pane"
																							@click="
																								showDisabledModal(
																									isPartDisabled(buildCase[1])
																								)
																							"
																						>
																							<div
																								:class="{
																									disabled: isPartDisabled(
																										buildCase[1]
																									)
																								}"
																								class="product-image"
																							>
																								<img
																									:src="buildCase[1].image"
																									alt=""
																								>
																							</div>
																							<p class="text-white">
																								{{ buildCase[1].description }}
																							</p>
																							<!-- selection-btn -->
																							<div class="cant-select">
																								<a
																									v-if="
																										!isPartDisabled(
																											buildCase[1]
																										) &&
																											!isModuleDisabled('cases')
																									"
																									class="text-white-i"
																									:class="
																										getSelectedClass(
																											'btn btn-green btn-outline',
																											getPrice(
																												'case',
																												buildCase[1].price,
																												null,
																												buildCase[1].products_id
																											)
																										)
																									"
																									@click="
																										addPartToBuild(
																											'case',
																											buildCase[1]
																										)
																									"
																								>
																									{{
																										getPrice(
																											"case",
																											buildCase[1].price,
																											null,
																											buildCase[1].products_id
																										)
																									}}
																								</a>
																								<disabled-button
																									v-else
																									buttons-type="single"
																								/>
																							</div>
																							<!-- /.selection-btn -->
																						</div>
																					</div>
																				</div>
																			</div>
																			<!-- thumb-n-info -->
																		</div>
																		<disabled-message
																			v-if="isModuleDisabled('cases')"
																			:message="isModuleDisabled('cases')"
																		/>
																		<!-- /.product -->
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="cases-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#cases"
																aria-expanded="false"
																aria-controls="cases"
																@click="changeActiveSubtab('case-options')"
															>
																Case
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- /cases -->
												<!-- cooling -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="cooling"
														:class="{ in: activeTab == 'cooling' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="cooling-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		COOLING
																	</h3>
																	<!-- extra-tabs -->
																	<ul class="nav nav-tabs full" role="tablist">
																		<li class="active" role="presentation">
																			<a
																				aria-controls="cooling-extras"
																				data-toggle="tab"
																				href="#cooling-extras"
																				role="tab"
																				aria-expanded="true"
																			>
																				CPU COOLERS
																			</a>
																		</li>
																		<li role="presentation">
																			<a
																				aria-controls="cooling-options"
																				class="cooling-options"
																				data-toggle="tab"
																				href="#cooling-options"
																				role="tab"
																				aria-expanded="false"
																			>
																				CASE FANS
																			</a>
																		</li>
																	</ul>
																	<!-- /.extra-tabs -->
																	<!-- extra-tabs-content  -->
																	<div class="tab-content">
																		<!-- motherboard-cooling -->
																		<div
																			id="cooling-extras"
																			:data-tab-disabled="
																				Boolean(isModuleDisabled('coolers'))
																			"
																			class="tab-pane active"
																		>
																			<div
																				v-for="cooler in cooling"
																				:key="'coolers-' + cooler.products_id"
																				:class="{
																					disabled: isPartDisabled(cooler)
																				}"
																				class="product-data p-x"
																				@click="
																					showDisabledModal(
																						isPartDisabled(cooler)
																					)
																				"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img :src="cooler.image" alt="" >
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ cooler.title }}
																						</h5>
																						<p class="text-white">
																							{{ cooler.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<a
																						v-if="
																							!isPartDisabled(cooler) &&
																								!isModuleDisabled('coolers')
																						"
																						class="text-white-i"
																						:class="
																							getSelectedClass(
																								'btn btn-green btn-outline',
																								getPrice(
																									'cpuCooler',
																									cooler.price,
																									getBuildPartIndex(
																										cooler.products_id,
																										'caseFans'
																									),
																									cooler.products_id
																								)
																							)
																						"
																						@click="
																							addPartToBuild(
																								'cpuCooler',
																								cooler
																							)
																						"
																					>
																						{{
																							getPrice(
																								"cpuCooler",
																								cooler.price,
																								getBuildPartIndex(
																									cooler.products_id,
																									"caseFans"
																								),
																								cooler.products_id
																							)
																						}}
																					</a>
																					<disabled-button
																						v-else
																						buttons-type="single"
																					/>
																				</div>
																			</div>
																			<disabled-message
																				v-if="isModuleDisabled('coolers')"
																				:message="isModuleDisabled('coolers')"
																			/>
																		</div>
																		<!-- /.motherboard-cooling -->
																		<!-- fan-cooling -->
																		<div
																			id="cooling-options"
																			:data-tab-disabled="
																				Boolean(isModuleDisabled('fans'))
																			"
																			class="tab-pane"
																		>
																			<div
																				v-for="fan in fans"
																				:key="'fans-' + fan.products_id"
																				:class="{
																					disabled: isPartDisabled(fan)
																				}"
																				class="product-data p-x"
																				@click="
																					showDisabledModal(isPartDisabled(fan))
																				"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img :src="fan.image" alt="" >
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ fan.title }}
																						</h5>
																						<p class="text-white">
																							{{ fan.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<template
																						v-if="
																							!isPartDisabled(fan) &&
																								!isModuleDisabled('fans')
																						"
																					>
																						<div class="green-drop">
																							<button
																								class="text-white-i"
																								:class="
																									getSelectedClass(
																										'btn btn-green',
																										getPrice(
																											'caseFans',
																											fan.price,
																											getBuildPartIndex(
																												fan.products_id,
																												'caseFans'
																											),
																											fan.products_id
																										)
																									)
																								"
																								type="button"
																								data-toggle="dropdown"
																								aria-haspopup="true"
																								aria-expanded="false"
																							>
																								{{
																									getBuildPartIndex(
																										fan.products_id,
																										"caseFans"
																									) >= 0
																										? build.caseFans[getBuildPartIndex(fan.products_id, "caseFans")].quantity
																										: "0"
																								}}
																								<span
																									class="m-l fa fa-chevron-down"
																								/>
																							</button>
																							<ul class="dropdown-menu">
																								<li>
																									<a
																										@click="
																											setBuildFans(fan, 'empty')
																										"
																									>
																										<p class="text-blue m-b-0">
																											0
																										</p>
																									</a>
																								</li>
																								<li
																									v-for="quantity in fan.availableQuantity"
																									:key="
																										'fans-' +
																											fan.products_id +
																											'-' +
																											quantity
																									"
																								>
																									<a
																										@click="
																											setBuildFans(
																												fan,
																												quantity
																											)
																										"
																									>
																										<p class="text-blue m-b-0">
																											{{ quantity }}
																										</p>
																									</a>
																								</li>
																							</ul>
																						</div>
																						<a
																							class="text-white-i"
																							:class="
																								getSelectedClass(
																									'btn btn-green btn-outline',
																									getPrice(
																										'caseFans',
																										fan.price,
																										getBuildPartIndex(
																											fan.products_id,
																											'caseFans'
																										),
																										fan.products_id
																									)
																								)
																							"
																							@click="
																								setBuildFans(
																									fan,
																									getBuildPartIndex(
																										fan.products_id,
																										'caseFans'
																									) >= 0
																										? 0
																										: 1
																								)
																							"
																						>
																							{{
																								getPrice(
																									"caseFans",
																									fan.price,
																									getBuildPartIndex(
																										fan.products_id,
																										"caseFans"
																									),
																									fan.products_id
																								)
																							}}
																						</a>
																					</template>
																					<disabled-button
																						v-else
																						buttons-type="double"
																					/>
																				</div>
																				<!-- /.selection-btn -->
																			</div>
																			<disabled-message
																				v-if="isModuleDisabled('fans')"
																				:message="isModuleDisabled('fans')"
																			/>
																		</div>
																		<!-- /.fan-cooling -->
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="cooling-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#cooling"
																aria-expanded="false"
																aria-controls="cooling"
																@click="changeActiveSubtab('cooling-options')"
															>
																Cooling
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- /.cooling -->
												<!-- motherboard -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="motherboard"
														:class="{ in: activeTab == 'motherboard' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="motherboard-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		MOTHERBOARD
																	</h3>
																	<div
																		:data-tab-disabled="
																			Boolean(isModuleDisabled('motherboards'))
																		"
																		class="product-content-wrapper"
																	>
																		<div
																			v-for="board in motherboards"
																			:id="`part-${board.products_id}`"
																			:key="'motherboards-' + board.products_id"
																			:class="{
																				disabled: isPartDisabled(board)
																			}"
																			class="product-data p-x"
																			@click="
																				showDisabledModal(isPartDisabled(board))
																			"
																		>
																			<!-- thumb-n-info -->
																			<div class="product-info-content m-b">
																				<div class="product-image">
																					<img :src="board.image" alt="" >
																				</div>
																				<div class="about-product">
																					<h5 class="text-bold text-white">
																						{{ board.title }}
																					</h5>
																					<p class="text-white">
																						{{ board.description }}
																					</p>
																				</div>
																			</div>
																			<!-- thumb-n-info -->
																			<!-- selection-btn -->
																			<div class="cant-select">
																				<a
																					v-if="
																						!isPartDisabled(board) &&
																							!isModuleDisabled('motherboards')
																					"
																					class="text-white-i btn btn-outline"
																					:class="
																						getSelectedClass(
																							'btn btn-green btn-outline',
																							getPrice(
																								'motherboard',
																								board.price,
																								null,
																								board.products_id
																							)
																						)
																					"
																					@click="
																						addPartToBuild('motherboard', board)
																					"
																				>
																					{{
																						getPrice(
																							"motherboard",
																							board.price,
																							null,
																							board.products_id
																						)
																					}}
																				</a>
																				<disabled-button
																					v-else
																					buttons-type="single"
																				/>
																			</div>
																			<!-- /.selection-btn -->
																		</div>
																		<disabled-message
																			v-if="isModuleDisabled('motherboards')"
																			:message="
																				isModuleDisabled('motherboards')
																			"
																		/>
																	</div>
																	<!-- /.product -->
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="motherboard-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#motherboard"
																aria-expanded="false"
																aria-controls="cooling"
																@click="
																	changeActiveSubtab('motherboard-options')
																"
															>
																MotherBoard
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- /.motherboard -->
												<!-- gpu-->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="gpu"
														:class="{ in: activeTab == 'gpu' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="gpu-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		GPU
																	</h3>
																	<div
																		:data-tab-disabled="
																			Boolean(isModuleDisabled('gpus'))
																		"
																		class="product-content-wrapper"
																	>
																		<div
																			v-for="card in gpu"
																			:key="'gpus-' + card.products_id"
																			:class="{
																				disabled: isPartDisabled(card)
																			}"
																			class="product-data p-x"
																			@click="
																				showDisabledModal(isPartDisabled(card))
																			"
																		>
																			<!-- thumb-n-info -->
																			<div class="product-info-content m-b">
																				<div class="product-image">
																					<img :src="card.image" >
																				</div>
																				<div class="about-product">
																					<h5 class="text-bold text-white">
																						{{ card.title }}
																					</h5>
																					<p class="text-white">
																						{{ card.description }}
																					</p>
																				</div>
																			</div>
																			<!-- thumb-n-info -->
																			<!-- selection-btn -->
																			<div class="cant-select">
																				<a
																					v-if="
																						!isPartDisabled(card) &&
																							!isModuleDisabled('gpus')
																					"
																					:class="
																						getSelectedClass(
																							'btn btn-green btn-outline',
																							build.gpu.products_id ==
																								card.products_id
																								? 'Selected'
																								: false
																						)
																					"
																					class="text-white-i"
																					@click="setBuildGpu(card)"
																				>
																					{{
																						card.products_id == build.gpu.products_id ? "SELECTED" : (card.price - build.gpu.price) | signedPrice
																					}}
																				</a>
																				<disabled-button
																					v-else
																					buttons-type="single"
																				/>
																			</div>
																			<!-- /.selection-btn -->
																		</div>
																		<disabled-message
																			v-if="isModuleDisabled('gpus')"
																			:message="isModuleDisabled('gpus')"
																		/>
																	</div>
																	<!-- /.product -->
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="gpu-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#gpu"
																aria-expanded="false"
																aria-controls="cooling"
																@click="changeActiveSubtab('gpu-options')"
															>
																GPU
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- /.gpu -->
												<!-- cpu-->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="cpu"
														:class="{ in: activeTab == 'cpu' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="cpu-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		CPU
																	</h3>
																	<div
																		:data-tab-disabled="
																			Boolean(isModuleDisabled('cpus'))
																		"
																		class="product-content-wrapper"
																	>
																		<div
																			v-for="processor in cpu"
																			:id="`part-${processor.products_id}`"
																			:key="'cpus-' + processor.products_id"
																			:class="{
																				disabled: isPartDisabled(processor)
																			}"
																			class="product-data p-x"
																			@click="
																				showDisabledModal(
																					isPartDisabled(processor)
																				)
																			"
																		>
																			<!-- thumb-n-info -->
																			<div class="product-info-content m-b">
																				<div class="product-image">
																					<img :src="processor.image" alt="" >
																				</div>
																				<div class="about-product">
																					<h5 class="text-bold text-white">
																						{{ processor.title }}
																					</h5>
																					<p class="text-white">
																						{{ processor.description }}
																					</p>
																				</div>
																			</div>
																			<!-- /.thumb-n-info -->
																			<!-- selection-btn -->
																			<div class="cant-select">
																				<a
																					v-if="
																						!isPartDisabled(processor) &&
																							!isModuleDisabled('cpus')
																					"
																					:class="
																						getSelectedClass(
																							'btn btn-green btn-outline',
																							getPrice(
																								'cpu',
																								processor.price,
																								null,
																								processor.products_id
																							)
																						)
																					"
																					class="text-white-i"
																					href="#"
																					@click="
																						addPartToBuild('cpu', processor)
																					"
																				>
																					{{
																						getPrice(
																							"cpu",
																							processor.price,
																							null,
																							processor.products_id
																						)
																					}}
																				</a>
																				<disabled-button
																					v-else
																					buttons-type="single"
																				/>
																			</div>
																			<!-- /.selection-btn -->
																		</div>
																		<disabled-message
																			v-if="isModuleDisabled('cpus')"
																			:message="isModuleDisabled('cpus')"
																		/>
																	</div>
																	<!-- /.product -->
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="cpu-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#cpu"
																aria-expanded="false"
																aria-controls="cooling"
																@click="changeActiveSubtab('cpu-options')"
															>
																CPU
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- /.cpu -->
												<!-- power-supplies-->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="power-supplies"
														:class="{ in: activeTab == 'psu' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="power-supplies-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		POWER SUPPLIES
																	</h3>
																	<!-- extra-tabs-content  -->
																	<div
																		:data-tab-disabled="
																			Boolean(isModuleDisabled('psus'))
																		"
																		class="product-content-wrapper"
																	>
																		<!-- psu-options -->
																		<div
																			id="psu-options"
																			class="tab-pane active"
																		>
																			<div
																				v-for="powerSupply in powerSupplies"
																				:key="'psus-' + powerSupply.products_id"
																				:class="{
																					disabled: isPartDisabled(powerSupply)
																				}"
																				class="product-data p-x"
																				@click="
																					showDisabledModal(
																						isPartDisabled(powerSupply)
																					)
																				"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img
																							:src="powerSupply.image"
																							alt=""
																						>
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ powerSupply.title }}
																						</h5>
																						<p class="text-white">
																							{{ powerSupply.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<a
																						v-if="
																							!isPartDisabled(powerSupply) &&
																								!isModuleDisabled('psus')
																						"
																						:class="
																							getSelectedClass(
																								'btn btn-green btn-outline',
																								getPrice(
																									'powerSupply',
																									powerSupply.price,
																									null,
																									powerSupply.products_id
																								)
																							)
																						"
																						class="text-white-i"
																						@click="
																							addPartToBuild(
																								'powerSupply',
																								powerSupply
																							)
																						"
																					>
																						{{
																							getPrice(
																								"powerSupply",
																								powerSupply.price,
																								null,
																								powerSupply.products_id
																							)
																						}}
																					</a>
																					<disabled-button
																						v-else
																						buttons-type="single"
																					/>
																				</div>
																				<!-- /.selection-btn -->
																			</div>
																		</div>
																		<!-- /.psu-options -->
																		<disabled-message
																			v-if="isModuleDisabled('psus')"
																			:message="isModuleDisabled('psus')"
																		/>
																	</div>
																	<!-- /.extra-tabs-content  -->
																	<!-- /.product -->
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="power-supplies-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#power-supplies"
																aria-expanded="false"
																aria-controls="cooling"
																@click="changeActiveSubtab('psu-options')"
															>
																Power Supplies
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- /.power-supplies -->
												<!-- ram-->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="ram"
														:class="{ in: activeTab == 'ram' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="ram-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		RAM
																	</h3>
																	<div
																		:data-tab-disabled="
																			Boolean(isModuleDisabled('ram'))
																		"
																		class="product-content-wrapper"
																	>
																		<div
																			v-for="(memory, mIdx) in ram"
																			:key="'ram-' + memory.products_id"
																			:class="{
																				disabled: isPartDisabled(memory)
																			}"
																			class="product-data p-x"
																			@click="
																				showDisabledModal(
																					isPartDisabled(memory)
																				)
																			"
																		>
																			<!-- thumb-n-info -->
																			<div class="product-info-content m-b">
																				<div class="product-image">
																					<img :src="memory.image" alt="" >
																				</div>
																				<div class="about-product">
																					<h5 class="text-bold text-white">
																						{{ memory.name }}
																						<small>(max speed)</small>
																						<span
																							v-if="
																								build.ram.products_id ==
																									memory.products_id
																							"
																							v-html="
																								computeRamCapacity(
																									build.ram.capacity,
																									memory.slots,
																									build.ram.quantity
																								)
																							"
																						/>
																						<span
																							v-else
																							v-html="
																								computeRamCapacity(
																									memory.capacity,
																									memory.slots
																								)
																							"
																						/>
																					</h5>
																					<p class="text-white">
																						{{ memory.description }}
																					</p>
																				</div>
																			</div>
																			<!-- thumb-n-info -->
																			<!-- selection-btn -->
																			<div class="cant-select">
																				<template
																					v-if="
																						!isPartDisabled(memory) &&
																							!isModuleDisabled('ram')
																					"
																				>
																					<div class="green-drop">
																						<button
																							:class="
																								getSelectedClass(
																									'btn btn-green',
																									build.ram.products_id ==
																										memory.products_id
																										? 'Selected'
																										: false
																								)
																							"
																							class="text-white-i btn"
																							type="button"
																							data-toggle="dropdown"
																							aria-haspopup="true"
																							aria-expanded="false"
																						>
																							{{
																								build.ram.products_id == memory.products_id ? build.ram.quantity : "0"
																							}}
																							<span
																								class="m-l fa fa-chevron-down"
																							/>
																						</button>
																						<ul class="dropdown-menu">
																							<li>
																								<a href="#">
																									<p class="text-blue m-b-0">
																										0
																									</p>
																								</a>
																							</li>
																							<li
																								v-for="quantity in 2"
																								:key="
																									'ram-' +
																										memory.products_id +
																										'-' +
																										quantity
																								"
																							>
																								<a
																									@click="
																										setBuildRAM(
																											memory,
																											null,
																											quantity
																										)
																									"
																								>
																									<p class="text-blue m-b-0">
																										{{ quantity }}
																									</p>
																								</a>
																							</li>
																						</ul>
																					</div>
																					<div class="green-drop">
																						<button
																							:class="
																								getSelectedClass(
																									'btn btn-green btn-outline',
																									build.ram.products_id ==
																										memory.products_id
																										? 'Selected'
																										: false
																								)
																							"
																							class="text-white-i btn"
																							type="button"
																							data-toggle="dropdown"
																							aria-haspopup="true"
																							aria-expanded="false"
																						>
																							{{
																								build.ram.products_id == memory.products_id
																									? getRealCapacity(memory.options.find(m => m.id == build.ram.id))
																									: `${getRealCapacity(memory.options[0])} ($${ram[0].price})`
																							}}
																							<span
																								class="m-l fa fa-chevron-down"
																							/>
																						</button>
																						<ul class="dropdown-menu">
																							<li
																								v-for="(option, oIdx) in memory.options"
																								:key="
																									'ram-' +
																										memory.products_id +
																										'-variant-' +
																										option.id +
																										mIdx +
																										oIdx
																								"
																							>
																								<a
																									@click="
																										setBuildRAM(memory, option)
																									"
																								>
																									<p class="text-blue m-b-0">
																										{{
																											getRealCapacity(option)
																										}}
																										({{
																											getPrice(
																												"ram",
																												option.price,
																												null,
																												option.products_id
																											)
																										}})
																									</p>
																								</a>
																							</li>
																						</ul>
																					</div>
																				</template>
																				<disabled-button
																					v-else
																					buttons-type="selects"
																				/>
																			</div>
																			<!-- /.selection-btn -->
																		</div>
																		<disabled-message
																			v-if="isModuleDisabled('ram')"
																			:message="isModuleDisabled('ram')"
																		/>
																	</div>
																	<!-- /.product -->
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="ram-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#ram"
																aria-expanded="false"
																aria-controls="cooling"
																@click="changeActiveSubtab('ram-options')"
															>
																RAM
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- /.ram -->
												<!-- storage-->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="storage"
														:class="{ in: activeTab == 'storage' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="storage-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		STORAGE
																	</h3>
																	<!-- extra-tabs -->
																	<ul class="nav nav-tabs full" role="tablist">
																		<li class="active" role="presentation">
																			<a
																				aria-controls="storage-ssd"
																				data-toggle="tab"
																				href="#storage-ssd"
																				role="tab"
																				aria-expanded="true"
																			>
																				SSD
																			</a>
																		</li>
																		<li role="presentation">
																			<a
																				aria-controls="storage-hdd"
																				data-toggle="tab"
																				href="#storage-hdd"
																				role="tab"
																				aria-expanded="false"
																			>
																				HDD
																			</a>
																		</li>
																	</ul>
																	<!-- /.extra-tabs -->
																	<!-- extra-tabs-content  -->
																	<div class="tab-content">
																		<!-- ssd -->
																		<div
																			id="storage-ssd"
																			:data-tab-disabled="
																				Boolean(isModuleDisabled('storage-ssd'))
																			"
																			class="tab-pane active"
																		>
																			<div
																				v-for="disk in ssd"
																				:key="'ssd-' + disk.products_id"
																				:class="{
																					disabled: isPartDisabled(disk)
																				}"
																				class="product-data p-x"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img :src="disk.image" alt="" >
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ disk.title }}
																						</h5>
																						<p class="text-white">
																							{{ disk.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<template
																						v-if="
																							!isPartDisabled(disk) &&
																								!isModuleDisabled('storage-ssd')
																						"
																					>
																						<div class="green-drop">
																							<button
																								class="text-white-i"
																								:class="
																									getSelectedClass(
																										'btn btn-green',
																										findDiskInBuildStorage(
																											disk.products_id,
																											'ssd'
																										)
																											? 'Selected'
																											: false
																									)
																								"
																								type="button"
																								data-toggle="dropdown"
																								aria-haspopup="true"
																								aria-expanded="false"
																							>
																								{{
																									findDiskInBuildStorage(
																										disk.products_id,
																										"ssd"
																									)
																										? findDiskInBuildStorage(disk.products_id, "ssd").quantity
																										: "0"
																								}}
																								<span
																									class="m-l fa fa-chevron-down"
																								/>
																							</button>
																							<ul class="dropdown-menu">
																								<li>
																									<a
																										@click="
																											setBuildStorage(
																												disk,
																												null,
																												'empty',
																												'ssd'
																											)
																										"
																									>
																										<p class="text-blue m-b-0">
																											0
																										</p>
																									</a>
																								</li>
																								<li
																									v-for="quantity in 3"
																									:key="
																										'ssd-' +
																											disk.products_id +
																											'-' +
																											quantity
																									"
																								>
																									<a
																										@click="
																											setBuildStorage(
																												disk,
																												null,
																												quantity,
																												'ssd'
																											)
																										"
																									>
																										<p class="text-blue m-b-0">
																											{{ quantity }}
																										</p>
																									</a>
																								</li>
																							</ul>
																						</div>
																						<div
																							v-if="disk.options"
																							class="green-drop"
																						>
																							<button
																								class="text-white-i"
																								:class="
																									getSelectedClass(
																										'btn btn-green btn-outline',
																										findDiskInBuildStorage(
																											disk.products_id,
																											'ssd'
																										)
																											? 'Selected'
																											: false
																									)
																								"
																								type="button"
																								data-toggle="dropdown"
																								aria-haspopup="true"
																								aria-expanded="false"
																							>
																								{{
																									findDiskInBuildStorage(
																										disk.products_id,
																										"ssd"
																									)
																										? findDiskInBuildStorage(disk.products_id, "ssd").capacity
																										: `${disk.options[0].capacity} ($${disk.options[0].price})`
																										| zeroed
																								}}
																								<span
																									class="m-l fa fa-chevron-down"
																								/>
																							</button>
																							<ul class="dropdown-menu">
																								<li
																									v-for="option in disk.options"
																									:key="
																										'ssd-' +
																											disk.products_id +
																											'-variant-' +
																											option.id
																									"
																								>
																									<a
																										@click="
																											setBuildStorage(
																												disk,
																												option,
																												null,
																												'ssd'
																											)
																										"
																									>
																										<p class="text-blue m-b-0">
																											{{
																												option.capacity | zeroed
																											}}
																											(+${{ option.price }})
																										</p>
																									</a>
																								</li>
																							</ul>
																						</div>
																					</template>
																					<disabled-button
																						v-else
																						buttons-type="selects"
																					/>
																					<!-- <a v-else href="#" class="btn btn-green btn-outline">+${{ disk.price | priceFormat }}</a> -->
																				</div>
																				<!-- /.selection-btn -->
																			</div>
																			<disabled-message
																				v-if="isModuleDisabled('storage-ssd')"
																				:message="
																					isModuleDisabled('storage-ssd')
																				"
																			/>
																		</div>
																		<!-- /.ssd -->
																		<!-- hdd -->
																		<div
																			id="storage-hdd"
																			:data-tab-disabled="
																				Boolean(isModuleDisabled('storage-hdd'))
																			"
																			class="tab-pane"
																		>
																			<div
																				v-for="disk in hdd"
																				:key="'hdd-' + disk.products_id"
																				:class="{
																					disabled: isPartDisabled(disk)
																				}"
																				class="product-data p-x"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img :src="disk.image" alt="" >
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ disk.title }}
																							{{ disk.options[0].capacity }}
																						</h5>
																						<p class="text-white">
																							{{ disk.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<template
																						v-if="
																							!isPartDisabled(disk) &&
																								!isModuleDisabled('storage-hdd')
																						"
																					>
																						<div class="green-drop">
																							<button
																								class="text-white-i"
																								:class="
																									getSelectedClass(
																										'btn btn-green',
																										findDiskInBuildStorage(
																											disk.products_id,
																											'hdd'
																										)
																											? 'Selected'
																											: false
																									)
																								"
																								type="button"
																								data-toggle="dropdown"
																								aria-haspopup="true"
																								aria-expanded="false"
																							>
																								{{
																									findDiskInBuildStorage(
																										disk.products_id,
																										"hdd"
																									)
																										? findDiskInBuildStorage(disk.products_id, "hdd").quantity
																										: "0"
																								}}
																								<span
																									class="m-l fa fa-chevron-down"
																								/>
																							</button>
																							<ul class="dropdown-menu">
																								<li>
																									<a
																										@click="
																											setBuildStorage(
																												disk,
																												null,
																												'empty',
																												'hdd'
																											)
																										"
																									>
																										<p class="text-blue m-b-0">
																											0
																										</p>
																									</a>
																								</li>
																								<li
																									v-for="quantity in 3"
																									:key="
																										'hdd-' +
																											disk.products_id +
																											'-' +
																											quantity
																									"
																								>
																									<a
																										@click="
																											setBuildStorage(
																												disk,
																												null,
																												quantity,
																												'hdd'
																											)
																										"
																									>
																										<p class="text-blue m-b-0">
																											{{ quantity }}
																										</p>
																									</a>
																								</li>
																							</ul>
																						</div>
																						<a
																							class="text-white-i"
																							:class="
																								getSelectedClass(
																									'btn btn-green btn-outline',
																									findDiskInBuildStorage(
																										disk.products_id,
																										'hdd'
																									)
																										? 'Selected'
																										: false
																								)
																							"
																							href="#"
																							@click="
																								setBuildStorage(
																									disk,
																									null,
																									1,
																									'hdd'
																								)
																							"
																						>
																							{{
																								getPrice(
																									"hdd",
																									disk.price,
																									getBuildPartIndex(
																										disk.products_id,
																										"hdd"
																									),
																									disk.products_id
																								)
																							}}
																						</a>
																					</template>
																					<disabled-button
																						v-else
																						buttons-type="selects"
																					/>
																				</div>
																				<!-- /.selection-btn -->
																			</div>
																			<disabled-message
																				v-if="isModuleDisabled('storage-hdd')"
																				:message="
																					isModuleDisabled('storage-hdd')
																				"
																			/>
																		</div>
																		<!-- /.hdd -->
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="storage-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#storage"
																aria-expanded="false"
																aria-controls="cooling"
																@click="changeActiveSubtab('ssd-options')"
															>
																Storage
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- /.storage -->
											</div>
											<!-- panel-group-for-options -->
										</div>
									</div>
									<!-- /.panel-body-CONFIGURE -->
									<!-- panel-body-EXTRAS -->
									<div
										id="collapseTwo"
										:class="{
											in:
												fromStep5 &&
												['color', 'software', 'services'].includes(activeTab)
										}"
										class="panel-collapse collapse"
										role="tabpanel"
										aria-labelledby="headingTwo"
									>
										<div class="panel-body">
											<!-- panel-group-for-options -->
											<div
												id="accordion3"
												class="panel-group"
												role="tablist"
												aria-multiselectable="true"
											>
												<!-- extra -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="extra"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="extra-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light tab-title"
																	>
																		ACCESSORIES
																	</h3>
																	<div class="tab-content">
																		<div
																			id="accessories-options"
																			:data-tab-disabled="
																				Boolean(isModuleDisabled('extras'))
																			"
																			class="product-content-wrapper"
																		>
																			<div
																				v-for="extra in extras"
																				:id="`part-${extra.products_id}`"
																				:key="'accessory-' + extra.products_id"
																				:class="{
																					[extra.product_class]: true,
																					disabled: isPartDisabled(extra)
																				}"
																				class="product-data p-x"
																				@click="
																					showDisabledModal(
																						isPartDisabled(extra)
																					)
																				"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img :src="extra.image" alt="" >
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ extra.title }}
																						</h5>
																						<p class="text-white">
																							{{ extra.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<a
																						v-if="
																							!isPartDisabled(extra) &&
																								!isModuleDisabled('extras')
																						"
																						:class="
																							getSelectedExtrasClass(
																								'btn btn-green btn-outline',
																								extra
																							)
																						"
																						@click="
																							setBuildExtrasUpgrades(
																								extra,
																								'extras',
																								extra.products_id
																							)
																						"
																					>
																						{{
																							getPrice(
																								"extras",
																								extra.price,
																								getBuildPartIndex(
																									extra.products_id,
																									"extras"
																								),
																								extra.products_id
																							)
																						}}
																					</a>
																					<disabled-button
																						v-else
																						buttons-type="single"
																					/>
																				</div>
																				<!-- /.selection-btn -->
																			</div>
																			<disabled-message
																				v-if="isModuleDisabled('extras')"
																				:message="isModuleDisabled('extras')"
																			/>
																		</div>
																	</div>
																	<!-- /.product -->
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="extra-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#extra"
																aria-expanded="false"
																aria-controls="extra"
																@click="changeActiveSubtab('extra-options')"
															>
																Accessories
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- extra -->
												<!-- peripherals -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="peripherals"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="peripherals-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light tab-title"
																	>
																		PERIPHERALS
																	</h3>
																	<div class="tab-content">
																		<div
																			id="peripherals-options"
																			:data-tab-disabled="
																				Boolean(isModuleDisabled('peripherals'))
																			"
																			class="product-content-wrapper"
																		>
																			<div
																				v-for="peripheral in peripherals"
																				:key="
																					'peripheral-' + peripheral.products_id
																				"
																				:class="{
																					disabled: isPartDisabled(peripheral)
																				}"
																				class="product-data p-x"
																				@click="
																					showDisabledModal(
																						isPartDisabled(peripheral)
																					)
																				"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img
																							:src="peripheral.image"
																							alt=""
																						>
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ peripheral.title }}
																						</h5>
																						<p class="text-white">
																							{{ peripheral.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<a
																						v-if="
																							!isPartDisabled(peripheral) &&
																								!isModuleDisabled('peripherals')
																						"
																						class="text-white-i"
																						:class="
																							getSelectedClass(
																								'btn btn-green btn-outline',
																								getPrice(
																									'peripherals',
																									peripheral.price,
																									getBuildPartIndex(
																										peripheral.products_id,
																										'peripherals'
																									),
																									peripheral.products_id
																								)
																							)
																						"
																						@click="
																							setBuildPeripherals(
																								peripheral,
																								'peripherals'
																							)
																						"
																					>
																						{{
																							getPrice(
																								"peripherals",
																								peripheral.price,
																								getBuildPartIndex(
																									peripheral.products_id,
																									"peripherals"
																								),
																								peripheral.products_id
																							)
																						}}
																					</a>
																					<disabled-button
																						v-else
																						buttons-type="single"
																					/>
																				</div>
																				<!-- /.selection-btn -->
																			</div>
																			<!-- /.product -->
																			<disabled-message
																				v-if="isModuleDisabled('peripherals')"
																				:message="
																					isModuleDisabled('peripherals')
																				"
																			/>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="peripherals-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#peripherals"
																aria-expanded="false"
																aria-controls="extra"
																@click="
																	changeActiveSubtab('peripheral-options')
																"
															>
																Peripherals
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- rgbs -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="rgbs"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="rgbs-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<!-- product -->
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		RGB
																	</h3>
																	<div
																		:data-tab-disabled="
																			Boolean(isModuleDisabled('rgbs'))
																		"
																		class="product-content-wrapper"
																	>
																		<div
																			v-for="buildRgb in groupedRgbs"
																			:key="'rgbs-' + buildRgb[0].id"
																			:class="{
																				selected:
																					build['rgbs'].some(
																						rgb => rgb.id == buildRgb[0].id
																					) ||
																					(buildRgb[1] &&
																						build['rgbs'].some(
																							rgb => rgb.id == buildRgb[1].id
																						))
																			}"
																			class="product-data p-x"
																		>
																			<!-- thumb-n-info -->
																			<div class="product-info-content m-b">
																				<div class="about-product">
																					<ul
																						class="nav nav-tabs full select-pc-tab"
																					>
																						<li
																							:class="{
																								active: build['rgbs'].some(
																									rgb =>
																										rgb.id == buildRgb[0].id
																								)
																							}"
																							@click="
																								showDisabledModal(
																									isPartDisabled(buildRgb[0])
																								)
																							"
																						>
																							<a
																								:href="'#rgb-' + buildRgb[0].id"
																								data-toggle="tab"
																								role="tab"
																								aria-expanded="true"
																								aria-controls="rgb-one"
																								@click="
																									!build['rgbs'].some(
																										rgb =>
																											rgb.id == buildRgb[0].id
																									) &&
																										setBuildPeripherals(
																											buildRgb[0],
																											'rgbs',
																											'id'
																										)
																								"
																							>
																								<h5
																									v-if="buildRgb[1]"
																									class="text-bold text-white"
																								>
																									{{ buildRgb[0].title }}
																									{{
																										!build["rgbs"].some(
																											rgb =>
																												rgb.id == buildRgb[0].id
																										)
																											? getTabPrice(buildRgb[0], buildRgb[1])
																											: ""
																									}}
																								</h5>
																								<h5
																									v-else
																									class="text-bold text-white"
																								>
																									{{ buildRgb[0].title }}
																								</h5>
																							</a>
																						</li>
																						<li
																							v-if="buildRgb[1]"
																							:class="{
																								active: build['rgbs'].some(
																									rgb =>
																										rgb.id == buildRgb[1].id
																								)
																							}"
																							@click="
																								showDisabledModal(
																									isPartDisabled(buildRgb[1])
																								)
																							"
																						>
																							<a
																								:href="'#rgb-' + buildRgb[1].id"
																								data-toggle="tab"
																								role="tab"
																								aria-expanded="false"
																								aria-controls="rgb-two"
																								@click="
																									!build['rgbs'].some(
																										rgb =>
																											rgb.id == buildRgb[1].id
																									) &&
																										setBuildPeripherals(
																											buildRgb[1],
																											'rgbs',
																											'id'
																										)
																								"
																							>
																								<h5
																									class="text-bold text-white"
																								>
																									{{ buildRgb[1].title }}
																									{{
																										!build["rgbs"].some(
																											rgb =>
																												rgb.id == buildRgb[1].id
																										)
																											? getTabPrice(buildRgb[1], buildRgb[0])
																											: ""
																									}}
																								</h5>
																							</a>
																						</li>
																					</ul>
																				</div>
																				<div class="about-product">
																					<div class="tab-content">
																						<div
																							:id="
																								'rgb-' + buildRgb[0].products_id
																							"
																							:class="{
																								active:
																									build['rgbs'].some(
																										rgb =>
																											rgb.id == buildRgb[0].id
																									) ||
																									!buildRgb[1] ||
																									(buildRgb[1] &&
																										!build['rgbs'].some(
																											rgb =>
																												rgb.id == buildRgb[1].id
																										)),
																								disabled: isPartDisabled(
																									buildRgb[0]
																								)
																							}"
																							class="tab-pane"
																							@click="
																								showDisabledModal(
																									isPartDisabled(buildRgb[0])
																								)
																							"
																						>
																							<div
																								:class="{
																									disabled: isPartDisabled(
																										buildRgb[0]
																									)
																								}"
																								class="product-image"
																							>
																								<img
																									:src="buildRgb[0].image"
																									alt=""
																								>
																							</div>
																							<p class="text-white">
																								{{ buildRgb[0].description }}
																							</p>
																							<!-- selection-btn -->
																							<div class="cant-select">
																								<a
																									v-if="
																										!isPartDisabled(
																											buildRgb[0]
																										) &&
																											!isModuleDisabled('rgbs')
																									"
																									class="text-white-i"
																									:class="
																										getSelectedClass(
																											'btn btn-green btn-outline',
																											getPrice(
																												'rgbs',
																												buildRgb[0].price,
																												getBuildPartIndex(
																													buildRgb[0]
																														.products_id,
																													'rgbs'
																												),
																												buildRgb[0].products_id
																											)
																										)
																									"
																									@click="
																										setBuildPeripherals(
																											buildRgb[0],
																											'rgbs',
																											'id'
																										)
																									"
																								>
																									{{
																										getPrice(
																											"rgbs",
																											buildRgb[0].price,
																											getBuildPartIndex(
																												buildRgb[0].products_id,
																												"rgbs"
																											),
																											buildRgb[0].products_id
																										)
																									}}
																								</a>
																								<disabled-button
																									v-else
																									buttons-type="single"
																								/>
																							</div>
																							<!-- /.selection-btn -->
																						</div>
																						<div
																							v-if="buildRgb[1]"
																							:id="
																								'rgb-' + buildRgb[1].products_id
																							"
																							:class="{
																								active: build['rgbs'].some(
																									rgb =>
																										rgb.id == buildRgb[1].id
																								),
																								disabled: isPartDisabled(
																									buildRgb[1]
																								)
																							}"
																							class="tab-pane"
																							@click="
																								showDisabledModal(
																									isPartDisabled(buildRgb[1])
																								)
																							"
																						>
																							<div
																								:class="{
																									disabled: isPartDisabled(
																										buildRgb[1]
																									)
																								}"
																								class="product-image"
																							>
																								<img
																									:src="buildRgb[1].image"
																									alt=""
																								>
																							</div>
																							<p class="text-white">
																								{{ buildRgb[1].description }}
																							</p>
																							<!-- selection-btn -->
																							<div class="cant-select">
																								<a
																									v-if="
																										!isPartDisabled(
																											buildRgb[1]
																										) &&
																											!isModuleDisabled('rgbs')
																									"
																									class="text-white-i"
																									:class="
																										getSelectedClass(
																											'btn btn-green btn-outline',
																											getPrice(
																												'rgbs',
																												buildRgb[0].price,
																												getBuildPartIndex(
																													buildRgb[0]
																														.products_id,
																													'rgbs'
																												),
																												buildRgb[0].products_id
																											)
																										)
																									"
																									@click="
																										setBuildPeripherals(
																											buildRgb[1],
																											'rgbs',
																											'id'
																										)
																									"
																								>
																									{{
																										getPrice(
																											"rgbs",
																											buildRgb[0].price,
																											getBuildPartIndex(
																												buildRgb[0].products_id,
																												"rgbs"
																											),
																											buildRgb[0].products_id
																										)
																									}}
																								</a>
																								<disabled-button
																									v-else
																									buttons-type="single"
																								/>
																							</div>
																							<!-- /.selection-btn -->
																						</div>
																					</div>
																				</div>
																			</div>
																			<!-- thumb-n-info -->
																		</div>
																		<!-- /.product -->
																		<disabled-message
																			v-if="isModuleDisabled('rgbs')"
																			:message="isModuleDisabled('rgbs')"
																		/>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->

													<div
														id="rgbs-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#rgbs"
																aria-expanded="false"
																aria-controls="rgbs"
																@click="changeActiveSubtab('rgbs-options')"
															>
																RGB
															</a>
														</h4>
													</div>
												</div>
												<!-- monitors -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="monitor"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="monitor-heading"
													>
														<div class="panel-body">
															<div class="panel-body">
																<div class="product-selection col-xs-12">
																	<div class="row">
																		<!-- product -->
																		<h3
																			class="text-white text-center text-light m-b-md"
																		>
																			MONITORS
																		</h3>
																		<div
																			:data-tab-disabled="
																				Boolean(isModuleDisabled('monitors'))
																			"
																			class="product-content-wrapper"
																		>
																			<div
																				v-for="monitor in monitors"
																				:key="'monitor-' + monitor.products_id"
																				:class="{
																					disabled: isPartDisabled(monitor)
																				}"
																				class="product-data p-x"
																				@click="
																					showDisabledModal(
																						isPartDisabled(monitor)
																					)
																				"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img :src="monitor.image" alt="" >
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ monitor.title }}
																						</h5>
																						<p class="text-white">
																							{{ monitor.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<template
																						v-if="
																							!isPartDisabled(monitor) &&
																								!isModuleDisabled('monitors')
																						"
																					>
																						<div class="green-drop">
																							<button
																								class="text-white-i"
																								:class="
																									getSelectedClass(
																										'btn btn-green',
																										findMonitor(
																											monitor.products_id
																										)
																											? 'Selected'
																											: false
																									)
																								"
																								type="button"
																								data-toggle="dropdown"
																								aria-haspopup="true"
																								aria-expanded="false"
																							>
																								{{
																									findMonitor(
																										monitor.products_id
																									)
																										? findMonitor(monitor.products_id).quantity
																										: "0"
																								}}
																								<span
																									class="m-l fa fa-chevron-down"
																								/>
																							</button>
																							<ul class="dropdown-menu">
																								<li>
																									<a
																										@click="
																											setMultipleBuildParts(
																												monitor,
																												'empty'
																											)
																										"
																									>
																										<p class="text-blue m-b-0">
																											0
																										</p>
																									</a>
																								</li>
																								<li
																									v-for="quantity in 3"
																									:key="
																										'monitor-' +
																											monitor.products_id +
																											'-' +
																											quantity
																									"
																								>
																									<a
																										@click="
																											setMultipleBuildParts(
																												monitor,
																												quantity
																											)
																										"
																									>
																										<p class="text-blue m-b-0">
																											{{ quantity }}
																										</p>
																									</a>
																								</li>
																							</ul>
																						</div>
																						<a
																							class="text-white-i"
																							:class="
																								getSelectedClass(
																									'btn btn-green btn-outline',
																									findMonitor(
																										monitor.products_id
																									)
																										? 'Selected'
																										: false
																								)
																							"
																							href="#"
																							@click="
																								setMultipleBuildParts(
																									monitor,
																									getBuildPartIndex(
																										monitor.products_id,
																										'monitors'
																									) >= 0
																										? 'empty'
																										: 1,
																									'monitors'
																								)
																							"
																						>
																							{{
																								getPrice(
																									"monitors",
																									monitor.price,
																									getBuildPartIndex(
																										monitor.products_id,
																										"monitors"
																									),
																									monitor.products_id
																								)
																							}}
																						</a>
																					</template>
																					<disabled-button
																						v-else
																						buttons-type="double"
																					/>
																				</div>
																				<!-- /.selection-btn -->
																			</div>
																			<disabled-message
																				v-if="isModuleDisabled('monitors')"
																				:message="isModuleDisabled('monitors')"
																			/>
																		</div>
																		<!-- /.product -->
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="monitor-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#monitor"
																aria-expanded="false"
																aria-controls="monitor"
																@click="changeActiveSubtab('monitor-options')"
															>
																Monitor
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- monitors -->
												<!-- color -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="color"
														:class="{ in: activeTab == 'color' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="color-heading"
													>
														<div class="panel-body">
															<div class="product-selection col-xs-12">
																<div class="row">
																	<h3
																		class="text-white text-center text-light m-b-md"
																	>
																		COLORS
																	</h3>
																	<div class="product-content-wrapper">
																		<!-- product -->
																		<div class="product-data p-x">
																			<!-- selection-btn -->
																			<div class="product-info-content m-b">
																				<div class="product-image">
																					<img
																						:src="build.case.render"
																						alt=""
																					>
																				</div>
																				<div class="about-product">
																					<h5 class="text-bold text-white">
																						{{ build.case.title }}
																					</h5>
																					<p class="text-white">
																						{{ build.case.description }}
																					</p>
																				</div>
																			</div>
																			<div class="color-selection">
																				<div class="color-wrap">
																					<div
																						v-for="(color, index) in casesColorsList"
																						:key="'case-color-' + index"
																						:class="
																							findColorInSelectedColors(color)
																						"
																						@click="setPartColor(color)"
																					>
																						<div
																							v-if="color.images_color_logo"
																							:id="
																								color.colors
																									? color.colors
																									: color.colors1.color
																									| lowerCase
																							"
																							:style="{
																								backgroundImage:
																									'url(' +
																									color.images_color_logo +
																									')',
																								backgroundSize: '100%'
																							}"
																						/>
																						<template v-else>
																							<div>
																								<div
																									:id="
																										color.colors
																											? color.colors
																											: color.colors1.color
																											  | lowerCase
																									"
																									class="color1"
																								/>
																								<div
																									v-if="color.colors2"
																									:id="
																										color.colors2
																											? color.colors2.color
																											: color.colors | lowerCase
																									"
																									class="color2"
																								/>
																							</div>
																						</template>
																						<p
																							class="color-text-disabled"
																							:class="
																								`${findColorInSelectedColors(
																									color,
																									true
																								)}`
																							"
																						>
																							Selected
																						</p>
																					</div>
																				</div>
																			</div>
																			<!-- /.selection-btn -->
																		</div>
																		<!-- /.product -->
																		<!-- product -->
																		<div
																			v-for="extra in extrasColorsList"
																			v-if="getBuildPartIndex(extra[0].products_id, 'extras') >= 0 && extra.length > 1"
																			:key="'extra-' + extra[0].products_id"
																			class="product-data p-x"
																		>
																			<div class="product-info-content m-b">
																				<div class="product-image">
																					<img
																						:src="
																							build.extras[
																								getBuildPartIndex(
																									extra[0].products_id,
																									'extras'
																								)
																							].render
																						"
																						alt=""
																					>
																				</div>
																				<div class="about-product">
																					<h5 class="text-bold text-white">
																						{{
																							build.extras[
																								getBuildPartIndex(
																									extra[0].products_id,
																									"extras"
																								)
																							].title
																						}}
																					</h5>
																					<p class="text-white">
																						{{
																							build.extras[
																								getBuildPartIndex(
																									extra[0].products_id,
																									"extras"
																								)
																							].description
																						}}
																					</p>
																				</div>
																			</div>
																			<div class="color-selection">
																				<div class="color-wrap">
																					<div
																						v-for="(color, index) in extra"
																						:class="
																							findColorInSelectedColors(color)
																						"
																						:key="'extra-color-' + index"
																						@click="setPartColor(color)"
																					>
																						<div>
																							<div
																								:id="
																									color.colors
																										? color.colors
																										: color.colors1.color
																										| lowerCase
																								"
																								class="color1"
																							/>
																							<div
																								v-if="color.colors2"
																								:id="
																									color.colors2
																										? color.colors2.color
																										: color.colors | lowerCase
																								"
																								class="color2"
																							/>
																						</div>
																						<p
																							class="color-text-disabled"
																							:class="
																								`${findColorInSelectedColors(
																									color,
																									true
																								)}`
																							"
																						>
																							Selected
																						</p>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div
																			v-if="
																				motherboardColorsList &&
																					motherboardColorsList.length > 1
																			"
																			class="product-data p-x"
																		>
																			<!-- selection-btn -->
																			<div class="product-info-content m-b">
																				<div class="product-image">
																					<img
																						:src="
																							build.cpuCooler.motherboards[
																								build.motherboard.id
																							].image
																						"
																						alt=""
																					>
																				</div>
																				<div class="about-product">
																					<h5 class="text-bold text-white">
																						{{ build.motherboard.title }}
																					</h5>
																					<p class="text-white">
																						{{ build.motherboard.description }}
																					</p>
																				</div>
																			</div>
																			<div class="color-selection">
																				<div class="color-wrap">
																					<div
																						v-for="(color, index) in motherboardColorsList"
																						:key="'mobo-color-' + index"
																						:class="
																							findColorInSelectedColors(color)
																						"
																						@click="setPartColor(color)"
																					>
																						<div
																							v-if="color.images_color_logo"
																							:id="
																								color.colors
																									? color.colors
																									: color.colors1.color
																									| lowerCase
																							"
																							:style="{
																								backgroundImage:
																									'url(' +
																									color.images_color_logo +
																									')',
																								backgroundSize: '100%'
																							}"
																						/>
																						<template v-else>
																							<div>
																								<div
																									:id="
																										color.colors
																											? color.colors
																											: color.colors1.color
																											| lowerCase
																									"
																									class="color1"
																								/>
																								<div
																									v-if="color.colors2"
																									:id="
																										color.colors2
																											? color.colors2.color
																											: color.colors | lowerCase
																									"
																									class="color2"
																								/>
																							</div>
																						</template>
																						<p
																							class="color-text-disabled"
																							:class="
																								`${findColorInSelectedColors(
																									color,
																									true
																								)}`
																							"
																						>
																							Selected
																						</p>
																					</div>
																				</div>
																			</div>
																			<!-- /.selection-btn -->
																		</div>
																		<!-- /.product -->
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="color-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#color"
																aria-expanded="false"
																aria-controls="color"
																@click="changeActiveSubtab('color-options')"
															>
																Color
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- /color -->
												<!-- software -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="software"
														:class="{ in: activeTab == 'software' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="software-heading"
													>
														<div class="panel-body">
															<div class="panel-body">
																<div class="product-selection col-xs-12">
																	<div class="row">
																		<!-- product -->
																		<h3
																			class="text-white text-center text-light m-b-md"
																		>
																			SOFTWARE
																		</h3>
																		<div class="product-content-wrapper">
																			<div
																				v-for="system in software"
																				:key="'software-' + system.products_id"
																				class="product-data p-x"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img :src="system.image" alt="" >
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ system.title }}
																						</h5>
																						<p class="text-white">
																							{{ system.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<a
																						class="text-white-i"
																						:class="
																							getSelectedClass(
																								'btn btn-green btn-outline',
																								getPrice(
																									'software',
																									system.price,
																									null,
																									system.products_id
																								)
																							)
																						"
																						@click="
																							addPartToBuild('software', system)
																						"
																					>
																						{{
																							getPrice(
																								"software",
																								system.price,
																								null,
																								system.products_id
																							)
																						}}
																					</a>
																				</div>
																				<!-- /.selection-btn -->
																			</div>
																		</div>
																		<!-- /.product -->
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="software-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#software"
																aria-expanded="false"
																aria-controls="software"
																@click="changeActiveSubtab('software-options')"
															>
																Software
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- software -->
												<!-- service -->
												<div class="panel panel-default">
													<!-- panel-body -->
													<div
														id="service-pc"
														:class="{ in: activeTab == 'services' }"
														class="panel-collapse collapse"
														role="tabpanel"
														aria-labelledby="service-pc-heading"
													>
														<div class="panel-body">
															<div class="panel-body">
																<div class="product-selection col-xs-12">
																	<div class="row">
																		<!-- product -->
																		<h3
																			class="text-white text-center text-light m-b-md"
																		>
																			SERVICE
																		</h3>
																		<div class="product-content-wrapper">
																			<div
																				v-for="system in services"
																				:key="'service-' + system.products_id"
																				class="product-data p-x"
																			>
																				<!-- thumb-n-info -->
																				<div class="product-info-content m-b">
																					<div class="product-image">
																						<img :src="system.image" alt="" >
																					</div>
																					<div class="about-product">
																						<h5 class="text-bold text-white">
																							{{ system.title }}
																						</h5>
																						<p class="text-white">
																							{{ system.description }}
																						</p>
																					</div>
																				</div>
																				<!-- thumb-n-info -->
																				<!-- selection-btn -->
																				<div class="cant-select">
																					<a
																						class="text-white-i"
																						:class="
																							getSelectedClass(
																								'btn btn-green btn-outline',
																								getPrice(
																									'services',
																									system.price,
																									null,
																									system.products_id
																								)
																							)
																						"
																						@click="
																							addPartToBuild('services', system)
																						"
																					>
																						{{
																							getPrice(
																								"services",
																								system.price,
																								null,
																								system.products_id
																							)
																						}}
																					</a>
																				</div>
																				<!-- /.selection-btn -->
																			</div>
																		</div>
																		<!-- /.product -->
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- /.panel-body -->
													<!-- panel-heading-selection -->
													<div
														id="service-heading"
														class="panel-heading"
														role="tab"
													>
														<h4 class="panel-title">
															<a
																class="collapsed btn btn-green text-white-i"
																role="button"
																data-toggle="collapse"
																data-parent="#accordion2"
																href="#service-pc"
																aria-expanded="false"
																aria-controls="software"
																@click="changeActiveSubtab('service-options')"
															>
																Service
															</a>
														</h4>
													</div>
													<!-- /.panel-heading-selection -->
												</div>
												<!-- software -->
											</div>
											<!-- panel-group-for-options -->
										</div>
									</div>
									<!-- /.panel-body-EXTRAS -->
									<!-- panel-heading-CONFIGURE -->
									<div id="headingOne" class="panel-heading" role="tab">
										<h4 class="panel-title">
											<a
												class="collapsed btn btn-green text-white-i toggle-menu-btn"
												role="button"
												data-toggle="collapse"
												data-parent="#accordion"
												href="#collapseOne"
												aria-expanded="false"
												aria-controls="collapseOne"
												@click="hideCustomSections()"
											>
												Configure
											</a>
										</h4>
									</div>
									<!-- /.panel-heading-CONFIGURE -->
									<!-- panel-heading-EXTRAS -->
									<div id="headingTwo" class="panel-heading" role="tab">
										<h4 class="panel-title">
											<a
												class="collapsed btn btn-green text-white-i toggle-menu-btn"
												role="button"
												data-toggle="collapse"
												data-parent="#accordion"
												href="#collapseTwo"
												aria-expanded="false"
												aria-controls="collapseTwo"
												@click="hideConfigureSections()"
											>
												EXTRAS
											</a>
										</h4>
									</div>
									<!-- /.panel-heading-EXTRAS -->
								</div>
							</div>
							<!-- /.options -->
						</div>
						<!-- option-panels -->
						<!-- checkout -->
						<a
							href="#"
							data-toggle="collapse"
							data-parent="#accordion"
							class="btn btn-orchid btn-block"
							@click="gotoStep5('bottom')"
						>
							Review &amp; Checkout
						</a>
						<!-- checkout -->
					</div>
				</div>
				<!-- /.pc-config-tlayout -->
				<div class="clearfix" />
			</div>
		</div>
		<!-- /.step-4-config -->
		<!-- /.steps-->
		<!-- scroll-to-budget -->
		<div v-show="showScrollOverlay" class="scroll-to outline-white">
			<button
				href="#"
				class="close-container bg-transparent no-border"
				@click="showScrollOverlay = false"
			>
				<img src="/assets/close-overlay.png" alt="Close" width="22" >
			</button>

			<div class="content text-white text-center">
				<div class="title">
					<h2>SCROLL DOWN</h2>
				</div>
				<h3 class="m-a-0">
					To configure
				</h3>
			</div>
		</div>
		<!-- /.scroll-to-budget -->
		<div id="share-overlay" class="modal fade in">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content text-center">
					<div class="modal-header text-center">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-header m-a-0">
						<h2 class="text-center text-white m-a-0">SHARE</h2>
					</div>
					<div class="modal-body">
						<div class="text-center">
							<div class="panel-user">
								<div class="row">
									<div class="col-md-12">
										<div class="text text-grey m-t">
											<p>
												USE THE LINK BELOW TO SHARE YOUR BUILD
											</p>
										</div>
										<div class="link m-b">
											<a
												id="clip"
												:href="fullPath"
												target="_blank"
												class="m-y"
											>
												{{ fullPath }}
											</a>
											<button
												id="copy-to-clip"
												class="btn btn-green btn-block btn-outline m-y"
												data-clipboard-target="#clip"
												@click="copyToClipboard('#clip')"
											>
												Click to copy
											</button>
										</div>
										<social-share-links />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="share-mail" class="modal fade in">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content text-center">
					<div class="modal-header text-center">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-header m-a-0">
						<h2 class="text-center text-white m-a-0">SHARE</h2>
					</div>
					<div class="modal-body">
						<div class="text-center">
							<div class="panel-user">
								<div class="row">
									<div class="col-md-12">
										<div class="text text-grey m-t">
											<p>
												Enter your email amd we will send you the build!
											</p>
										</div>
										<div class="link m-b">
											<a
												id="clip"
												:href="fullPath"
												target="_blank"
												class="m-y"
											>
												{{ fullPath }}
											</a>
											<template v-if="!emailSent">
												<div class="form-group field m-t">
													<input
														v-model="email"
														autofocus
														placeholder="Email"
														type="email"
														class="form-control"
														name="share_email"
														required
														data-vv-as="Email"
														v-validate="'required|email'"
													>
												</div>
												<span
													v-show="errors.has('share_email')"
													class="text-danger text-left"
												>
													{{ errors.first("share_email") }}
												</span>
												<button
													v-if="!emailSent"
													class="btn btn-green btn-block btn-outline m-y"
													@click="sendBuildToEmail()"
												>
													SEND
												</button>
											</template>
											<button
												v-if="emailSent"
												class="btn btn-green btn-block btn-outline m-y"
												@click="(emailSent = false), (email = '')"
											>
												SENT
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- save -->
		<div v-if="!POS_MODE" id="save-bld" class="modal fade in">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content text-center">
					<div class="modal-header text-center">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-header m-a-0">
						<h2 class="text-center text-white m-a-0">SHARE YOUR BUILD</h2>
					</div>
					<div class="modal-body">
						<div class="text-center">
							<div class="panel-user">
								<div class="row">
									<div class="col-md-12">
										<div class="text text-grey m-t">
											<p>
												CLICK THE LINK BELOW TO SHARE
											</p>
										</div>
										<div class="link m-b">
											<a
												id="clip"
												:href="fullPath"
												target="_blank"
												class="m-y"
											>
												{{ fullPath }}
											</a>
											<h4 class="text-center text-white m-y">OR</h4>
											<router-link
												:to="{ path: '/user/account?currentTab=saved-build' }"
											>
												SEE ALL YOUR SAVED BUILDS
											</router-link>
											<div class="breadcrumb-build">BUILDS &gt; Saved</div>
										</div>
										<social-share-links />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /.save -->
		<!-- vr -->
		<div id="vr-modal" class="modal fade in" tabindex="-1" role="dialog">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">×</span>
						</button>
						<h2 class="text-white">Your build is VR Ready!</h2>
					</div>
					<div class="modal-body text-white">
						<p class="text-center">
							This means your PC meets the minimum recommended specs to play
							games on the Oculus Rift, HTC VIVE and other VR devices.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!-- /.vr -->
		<!-- vr -->
		<div id="streaming-modal" class="modal fade in" tabindex="-1" role="dialog">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">×</span>
						</button>
						<h2 class="text-white">Your build is Stream Ready!</h2>
					</div>
					<div class="modal-body text-white">
						<p class="text-center">
							Your PC will be capable of streaming most games in 720p with 60fps
							or better, provided your connection has at least 10mbps upload
							speed, and the streamed game typically runs at or above 60fps.
							Slower internet upload speeds may have mixed results.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!-- /.vr -->
		<div id="rule-modal" class="modal fade in" tabindex="-1" role="dialog">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">×</span>
						</button>
						<h2 class="text-white">{{ ruleTitle }}</h2>
					</div>
					<div class="modal-body text-white">
						<p
							v-for="(text, index) in ruleText"
							:key="'rule-' + index"
							class="text-center"
						>
							<span v-html="text" />
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable no-prototype-builtins */
import { mapActions, mapState } from "vuex";
import { Validator } from "vee-validate";
import { heapAnalytics } from "../../../util/mixins";
import { getUserData } from "@u/helpers";
import { computeRamCapacity } from "@u/store-helpers";
import ConfiguratorMixin from "@m/configurator";
import DisabledButton from "./step-4/components/products-tabs/components/tab-content/components/tab-row/components/disabled-button";
import DisabledMessage from "./step-4/components/products-tabs/components/tab-content/components/tab-row/components/disabled-message";
import FastClick from "fastclick";
import PosModeModal from "./pos-mode-modal";
import socialShareLinks from "./step-4/social-share-links";
import PromoSalesTimed from "@/components/promo-sales-timed";
import { casePromo, promoDiscount } from "@u/helpers";

$.urlParam = function urlParam(name) {
	const results = new RegExp(",?" + name + "=([^,]*)").exec(
		window.location.hash
	);

	if (Array.isArray(results)) {
		return results[1] || 0;
	}

	return 0;
};

export default {
	name: "Step4Mobile",
	components: {
		DisabledButton,
		DisabledMessage,
		socialShareLinks,
		PosModeModal,
		PromoSalesTimed
	},
	filters: {
		priceFormat(value) {
			value = value ? value : 0;
			value = parseFloat(value).toFixed(2);
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
		lowerCase: function(value) {
			if (!value) {
				return "";
			}
			value = value.toString();
			return value.toLowerCase();
		},
		signedPrice(value) {
			if (!value) {
				return `+$0`;
			}
			if (typeof value == "string") {
				return value;
			}
			value = Number(value).toFixed(2);
			if (value > 0) {
				return `+$${value}`;
			} else {
				value *= -1;
				return `-$${value}`;
			}
		},
		zeroed(value) {
			return value.replace(/\.0{1,}/, "");
		}
	},
	mixins: [ConfiguratorMixin, heapAnalytics],
	data() {
		return {
			duplicated: false,
			compatibility: {
				lighting: true,
				wifi: true,
				bluetooth: true,
				fanControl: true
			},
			isLoading: true,
			overviewOpen: false,
			email: "",
			loadingText: "CALCULATING",
			ruleText: [],
			ruleTitle: "NOTE",
			emailSent: false,
			showScrollOverlay: true,
			isPreventRule: false,
			prevQuantity: 0,
			fullPath: window.location.href,
			shouldShowBar: false,
			disabledModalTimer: null
		};
	},
	computed: {
		...mapState({
			activeRules: state => state.Step4.activeRules,
			disableRules: state => state.Step4.disableRules,
			activeTab: state => state.Step4.activeTab,
			activeSubtab: state => state.Step4.activeSubtabs[state.Step4.activeTab],
			build: state => state.Step4.activeBuild,
			buildPrice: state => state.Step4.buildPrice,
			games: state => state.Step4.sessionGamesData,
			sessionData: state => state.Step4.sessionData,
			fromStep5: state => state.Step4.fromStep5
		}),
		applyCase() {
			return casePromo(this.discountCase);
		},
		discountPrice() {
			return promoDiscount(this.buildPrice);
		},
		discountCase() {
			return this.build.case || {};
		},
		disabledRules() {
			const disabledRules = {
				modules: {},
				products: {}
			};

			this.disableRules.forEach(rule => {
				if (rule.ruleType == "disable-all") {
					disabledRules.modules[rule.partToChange] = rule.msg;
				}

				if (rule.ruleType == "disable") {
					disabledRules.products[
						`${rule.products.products_id}-${rule.products.id}`
					] = rule.msg;
				}
			});

			return disabledRules;
		},
		buildCases() {
			return this.sessionData.case || [];
		},
		colors() {
			return this.sessionData.colors;
		},
		cooling() {
			return this.sessionData.cooling;
		},
		cpu() {
			return this.sessionData.cpu;
		},
		extras() {
			return this.sessionData.extras;
		},
		fans() {
			return this.sessionData.fans;
		},
		gpu() {
			return this.sessionData.gpu;
		},
		hdd() {
			return this.sessionData.hdd;
		},
		monitors() {
			return this.sessionData.monitors;
		},
		motherboards() {
			return this.sessionData.motherboards;
		},
		peripherals() {
			return this.sessionData.peripherals;
		},
		powerSupplies() {
			return this.sessionData.powerSupplies;
		},
		ram() {
			return this.sessionData.ram;
		},
		rgbs() {
			return this.sessionData.rgbs || [];
		},
		selectedColors() {
			return this.build.colors;
		},
		services() {
			return this.sessionData.services;
		},
		software() {
			return this.sessionData.software;
		},
		ssd() {
			return this.sessionData.ssd;
		},
		storage() {
			return this.sessionData.storage;
		},
		streamingBundle() {
			return this.sessionData.streamingBundle;
		},
		userData: () => getUserData(),
		casesColorsList() {
			return _.groupBy(this.colors.case, "products_id")[
				this.build.case.products_id
			];
		},
		extrasColorsList() {
			return _.groupBy(this.colors.extras, "products_id");
		},
		peripheralsColorsList() {
			return _.groupBy(this.colors.peripherals, "products_id");
		},
		motherboardColorsList() {
			return _.groupBy(this.colors.motherboards, "products_id")[
				this.build.motherboard.products_id
			];
		},
		groupedCases() {
			const orderedCases = {};

			this.buildCases.forEach(_case => {
				if (!orderedCases.hasOwnProperty(`_${_case.cases_series_id}`)) {
					orderedCases[`_${_case.cases_series_id}`] = [];
				}

				orderedCases[`_${_case.cases_series_id}`].push(_case);
				orderedCases[`_${_case.cases_series_id}`].reverse();
			});

			return orderedCases;
		},
		groupedRgbs() {
			const rgbs = [];

			this.rgbs.forEach(rgb => {
				if (rgb.name.match(/hue ?2 ambient/i)) {
					rgb.options.forEach(ambient => {
						ambient.cases_series_id = 1;
						ambient.description = ambient.variant_description;
						ambient.image = rgb.image;
						ambient.render = rgb.render;
					});

					rgbs.push(rgb.options);
				} else {
					rgbs.push([rgb]);
				}
			});

			return rgbs;
		}
	},
	watch: {
		activeRules: {
			handler() {
				this.applyRules();
			},
			deep: true
		},
		build: {
			handler(current, previous) {
				if (window.localStorage.hasOwnProperty("session-draft")) {
					if (this.draftId == window.localStorage.getItem("session-draft")) {
						this.setLocalStorageVuex();
						this.updateBuildInDatabase();
					}

					if (this.duplicated) {
						this.$store.dispatch("setActiveBuild", previous);
						this.duplicated = false;
					}
				} else {
					if (!_.isEmpty(previous)) {
						this.duplicated = true;
						this.duplicateBuild();
					}
				}
			},
			deep: true
		},
		overviewOpen: {
			handler(isOpen) {
				if (isOpen) {
					if (!this.shouldShowBar) {
						$(".row.specs").on("scroll", () => {
							this.shouldShowBar = true;
							$(".row.specs").off("scroll");
						});
					}
				} else {
					this.shouldShowBar = false;
				}
			},
			deep: true
		}
	},
	created() {
		EventBus.$on("save-build", () => {
			if (Cookies.get("cookies_id")) {
				this.shareBuild("#save-bld");
			}
		});
	},
	mounted() {
		FastClick.attach(this.$el);
		this.configureValidationMessages();

		const initialScroll = window.scrollY;
		$(window).on("scroll", () => {
			if (initialScroll != window.scrollY) {
				this.showScrollOverlay = false;
			}
		});
		$(window).one("click", () => {
			this.showScrollOverlay = false;
		});

		const ratio = window.devicePixelRatio || 1;

		const screen = {
			width: window.screen.width * ratio,
			height: window.screen.height * ratio
		};

		// iPhone X Detection
		if (screen.width >= 1125 && screen.height >= 2436) {
			this.showScrollOverlay = false;
		}

		$("#share-mail").on("hidden.bs.modal", () => {
			this.email = "";
			this.emailSent = false;
			this.$validator.reset();
		});

		$("#rule-modal").on("hidden.bs.modal", () => {
			$("#rule-modal").removeClass("disabled-modal");
			clearTimeout(this.disabledModalTimer);
		});
	},
	async beforeRouteLeave(to, from, next) {
		await this.setFromStep5(false);
		next();
	},
	methods: {
		...mapActions([
			"setBuildPrice",
			"changeActiveRules",
			"setFromStep5",
			"changeActiveSubtab",
			"changeSessionGamesData"
		]),
		computeRamCapacity,
		isPartDisabled(part) {
			return this.disabledRules.products[`${part.products_id}-${part.id}`];
		},
		isModuleDisabled(module) {
			return this.disabledRules.modules[module];
		},
		changeBuild({ data: pricingData }) {
			if (pricingData.total) {
				if (pricingData.rules) {
					this.changeActiveRules(pricingData.rules);
				}
				this.$store.dispatch("setActiveBuild", pricingData.build);
				this.setBuildPrice(pricingData.total);
			} else {
				if (pricingData.price) {
					this.setBuildPrice(pricingData.price);
				} else {
					this.setBuildPrice(pricingData);
				}
			}
		},
		addPartToBuild(partName, part) {
			axios({
				url: `/update-part/${part.id}/${this.build[partName].id}?pid=${part.products_id}&validate=true&step4=true`,
				method: "GET",
				headers: {
					token: CONFIG.SESSION
				}
			}).then(response => {
				this.changeBuild(response);

				if (partName == "cpu") {
					this.getGamesFPS(part.products_id, this.build.gpu.products_id);
				}
			});
		},
		getGamesFPS(cpuId, gpuId) {
			const resolution =
				this.sessionData.resolutionText == "1920x1080" ? "1080" : "1440";
			axios({
				url: `/games-fps?cpu=${cpuId}&gpu=${gpuId}&resolution=${resolution}`,
				method: "GET",
				headers: {
					token: CONFIG.SESSION
				}
			}).then(response => {
				const gamesInfo = response.data;
				const sessionGames = _.cloneDeep(this.games);
				for (var i = 0; i < sessionGames.length; i++) {
					sessionGames[i].game_value = gamesInfo[sessionGames[i].games_id] || 0;
				}
				this.changeSessionGamesData(sessionGames);
			});
		},
		configureValidationMessages() {
			const dictionary = {
				en: {
					custom: {
						share_email: {
							email:
								"You did not enter in a valid email address. Please try again.",
							required: "You must enter in an email address."
						}
					}
				}
			};

			Validator.localize(dictionary);
		},
		copyToClipboard(element) {
			const $temp = $("<input>");
			$("body").append($temp);
			$temp.val($(element).text()).select();
			document.execCommand("copy");
			$temp.remove();
		},
		openCloseOverview(isCheckout) {
			if (!this.overviewOpen) {
				this.setCompatibilityIcons();
				$(".overview-overlay").show();
				if (isCheckout) {
					$(".final-review").show();
				} else {
					$(".final-review").hide();
				}
				this.overviewOpen = true;
			} else {
				$(".overview-overlay").hide();
				this.overviewOpen = false;
			}
		},
		getPrice(partName, partPrice, partIndex, productId) {
			let price = partPrice;

			if (parseFloat(price) == 0) {
				return price;
			}

			if (this.build[partName] && this.build[partName].price) {
				if (this.build[partName].quantity) {
					price =
						Number(partPrice) * Number(this.build[partName].quantity) -
						Number(this.build[partName].price) *
							Number(this.build[partName].quantity);
				} else {
					price = Number(partPrice) - Number(this.build[partName].price);
				}
			}

			if (partName && partIndex != null && partIndex >= 0) {
				price =
					Number(partPrice) - Number(this.build[partName][partIndex].price);
			}

			price = Number.parseFloat(price).toFixed(2);

			let pId = this.build[partName].products_id;
			if (!pId && partIndex >= 0) {
				pId = this.build[partName][partIndex].products_id;
			}

			let results =
				pId == productId
					? "Selected"
					: price > 0
						? `+$${price}`
						: `-$${price * -1}`;

			if (results == "-$0") {
				results = "$0";
			}

			if (
				results == "Selected" &&
				(partName == "caseFans" || partName == "hdd" || partName == "monitors")
			) {
				results = "Selected";
			}

			return results;
		},
		setCompatibilityIcons() {
			this.compatibility.wifi = false;
			this.compatibility.lighting = false;
			this.compatibility.bluetooth = this.build.motherboard.bluetooth == 1;
			this.compatibility.fanControl = false;

			//light
			const modules = [
				"cpuCooler",
				"ram",
				"motherboard",
				"case",
				"caseFans",
				"peripherals",
				"extras"
			];
			modules.forEach(productModule => {
				if (productModule in this.build) {
					const product = this.build[productModule];
					if (_.isArray(product)) {
						product.forEach(variant => {
							this.compatibility.lighting =
								this.compatibility.lighting || variant.cam_lighting == 1;
							this.compatibility.wifi =
								this.compatibility.wifi || variant.wifi == 1;
							this.compatibility.fanControl =
								this.compatibility.fanControl || variant.fan_control == 1;
						});
					} else {
						this.compatibility.lighting =
							this.compatibility.lighting || product.cam_lighting == 1;
						this.compatibility.wifi =
							this.compatibility.wifi || product.wifi == 1;
						this.compatibility.fanControl =
							this.compatibility.fanControl || product.fan_control == 1;
					}
				}
			});
		},
		findDiskInBuildStorage(productId, diskType) {
			return this.build[diskType].find(disk => disk.products_id == productId);
		},
		findMonitor(productId) {
			return this.build.monitors.find(monitor => {
				return monitor && monitor.products_id == productId;
			});
		},
		findColorInSelectedColors(selectedColor, shouldShowSelectedText) {
			const result = this.selectedColors.find(color => {
				return (
					color &&
					color.products_id == selectedColor.products_id &&
					color.id == selectedColor.id
				);
			});

			if (shouldShowSelectedText && result) {
				return "color-text-indicator-active";
			} else if (result) {
				return "color-wrap-option case-color swatch-color-Black-Red selected";
			} else {
				return "color-wrap-option case-color swatch-color-Black-Red";
			}
		},
		setBuildRAM(memory, selectedOption, quantity) {
			quantity = quantity ? quantity : this.build.ram.quantity || 1;
			selectedOption = selectedOption ? selectedOption : memory.options[0];

			axios({
				url: `/update-part/${selectedOption.id}/${this.build.ram.id}/${quantity}?pid=${memory.products_id}&validate=true&step4=true`,
				method: "GET",
				headers: {
					token: CONFIG.SESSION
				}
			}).then(response => {
				this.changeBuild(response);
			});
		},
		setBuildStorage(disk, selectedOption, quantity, diskType) {
			const storageInBuild = this.build[diskType].find(
				storage => storage.products_id == disk.products_id
			);
			const storageInTypeList = this[diskType].find(
				storage => storage.products_id == disk.products_id
			).options[0];

			selectedOption = selectedOption || storageInBuild || storageInTypeList;
			quantity =
				quantity == "empty" ? 0 : quantity || selectedOption.quantity || 1;

			if (quantity == 0) {
				axios({
					url: `/delete-part/${selectedOption.id}?pid=${selectedOption.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			} else {
				axios({
					url: `/update-part/${selectedOption.id}/${selectedOption.id}/${quantity}?pid=${selectedOption.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			}
		},
		setBuildExtrasUpgrades(part, partName) {
			if (this.getBuildPartIndex(part.products_id, partName) >= 0) {
				axios({
					url: `/delete-part/${part.id}?pid=${part.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			} else {
				axios({
					url: `/update-part-qty/${part.id}/1?pid=${part.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			}
		},
		setBuildPeripherals(part, partName, refId = "products_id") {
			if (
				this.getBuildPartIndex(part[refId], partName, refId) >= 0 ||
				this.build[partName].id == part.id
			) {
				axios({
					url: `/delete-part/${part.id}?pid=${part.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			} else {
				axios({
					url: `/update-part-qty/${part.id}/1?pid=${part.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			}
		},
		getBuildPartIndex(productId, partName, refId = "products_id") {
			return _.findIndex(this.build[partName], {
				[refId]: productId
			});
		},
		setBuildGpu(videoCard, quantity) {
			quantity = quantity ? quantity : this.build.gpu.quantity || 1;

			axios({
				url: `/update-part/${videoCard.id}/${this.build.gpu.id}/${quantity}?pid=${videoCard.products_id}&validate=true&step4=true`,
				method: "GET",
				headers: {
					token: CONFIG.SESSION
				}
			}).then(response => {
				this.changeBuild(response);
				this.getGamesFPS(this.build.cpu.products_id, videoCard.products_id);
			});
		},
		setPartColor(color) {
			const colorIndex = _.findIndex(this.selectedColors, {
				products_id: color.products_id
			});

			if (colorIndex >= 0) {
				this.selectedColors[colorIndex] = color;
			} else {
				this.selectedColors.push(color);
			}

			this.loadingText = "LOADING...";
			this.isLoading = true;

			axios({
				url: `/update-part-color/${color.products_id}/${color.id}`,
				method: "GET",
				headers: {
					token: CONFIG.SESSION
				}
			}).then(response => {
				this.changeBuild(response);

				this.isLoading = false;
			});
		},
		setBuildFans(fan, quantity) {
			quantity = quantity == "empty" ? 0 : quantity || 1;

			if (quantity == 0) {
				axios({
					url: `/delete-part/${fan.id}?pid=${fan.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			} else {
				axios({
					url: `/update-part/${fan.id}/${fan.id}/${quantity}?pid=${fan.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			}
		},
		setMultipleBuildParts(partInfo, quantity) {
			quantity = quantity == "empty" ? 0 : quantity || 1;

			if (quantity == 0) {
				axios({
					url: `/delete-part/${partInfo.id}?pid=${partInfo.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			} else {
				axios({
					url: `/update-part/${partInfo.id}/${partInfo.id}/${quantity}?pid=${partInfo.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuild(response);
				});
			}
		},
		changeLoadingText(message) {
			this.loadingText = message;
		},
		changeShowLoadingOverlay(state) {
			this.isLoading = state;
		},
		showErrorModal(message, title = "ERROR", options = {}) {
			this.ruleTitle = title;
			this.ruleText = [message];
			$("#rule-modal").modal(options);
		},
		showDisabledModal(message) {
			clearTimeout(this.disabledModalTimer);

			if (message) {
				$("#rule-modal").addClass("disabled-modal");
				this.showErrorModal(message, "NOTE", { backdrop: false });

				this.disabledModalTimer = setTimeout(() => {
					$("#rule-modal").modal("hide");
				}, 3000);
			}
		},
		getSelectedClass(classString, string) {
			if (string == "Selected") {
				return classString + " selected";
			}
			return classString;
		},
		getSelectedExtrasClass(classString, extraPart) {
			if (
				this.build.extras &&
				this.build.extras.find(extra => extra.id === extraPart.id)
			) {
				return classString + " selected";
			}

			return classString;
		},
		shareBuild(elementId) {
			this.emailSent = false;
			const bodyFormData = new FormData();
			bodyFormData.append("bld_number_draft", this.draft);
			this.loadingText = "GENERATING";
			this.isLoading = true;
			axios({
				url: `/share?bld_number=${this.draft}`,
				method: "POST",
				data: bodyFormData,
				headers: {
					token: CONFIG.SESSION
				}
			}).then(response => {
				const previousDraft = this.draft;
				this.draft = response.data;
				axios({
					url: `/users/0/letsbld-drafts/${previousDraft}?session=${CONFIG.SESSION}`,
					method: "PUT",
					headers: {
						token: CONFIG.SESSION
					}
				}).then(() => {
					this.isLoading = false;
					$(elementId).modal("show");
				});
			});
		},
		saveBuild() {
			const userData = getUserData();
			if (!userData.cookies_id) {
				this.$modal.show("login-modal", { shouldSaveBuildOnClose: true });
			} else {
				this.shareBuild("#save-bld");
			}
		},
		hideSections() {
			$(
				"#collapseTwo, #collapseOne, #collapseTwo .in, #collapseOne .in"
			).collapse("hide");
		},
		hideConfigureSections() {
			this.hideSections();
			$(`#collapseTwo`).collapse("toggle");
		},
		hideCustomSections() {
			this.hideSections();
			$(`#collapseOne`).collapse("toggle");
		},
		applyRules() {
			const rules = _.cloneDeep(this.activeRules);

			if (rules.length) {
				this.ruleTitle = "NOTE";
				this.ruleText = [];

				rules.forEach(element => {
					if (
						!["disable", "disable-all", "enable", "enable-all"].includes(
							element.ruleType
						)
					) {
						this.ruleText.push(element.msg);
					}
				});

				if (this.ruleText.length) {
					$("#rule-modal").modal();
				}
			} else {
				return;
			}
		},
		async sendBuildToEmail() {
			const isValid = await this.$validator.validateAll();

			if (!isValid) {
				return;
			}

			this.emailSent = true;

			const bodyFormData = new FormData();
			bodyFormData.append("email", this.email);
			axios({
				url: `/vr-draft/${this.draft}/email`,
				method: "POST",
				data: bodyFormData
			})
				.then(response => {
					toastr.success(response.data[0]);
				})
				.catch(error => {
					toastr.error(error, "Error");
				});
		},
		getTabPrice(higherPriceBuild, lowerPriceBuild) {
			if (
				higherPriceBuild.products_id == this.build.case.products_id ||
				lowerPriceBuild.products_id == this.build.case.products_id
			) {
				let price =
					Number(higherPriceBuild.price) - Number(lowerPriceBuild.price);
				price =
					price > 0
						? `(+$${Math.trunc(price)})`
						: `(-$${Math.trunc(price) * -1})`;
				return price;
			} else {
				return "";
			}
		},
		getRealCapacity(part) {
			if (!part && !part.capacity) {
				return "";
			}

			const suffix = part.capacity.match(/([^\d]+)/)[0].trim();
			const realSize = parseInt(part.capacity) * Math.abs(part.slots);

			return `${realSize} ${suffix}`;
		},
		showLoading() {
			this.isLoading = true;
		},
		hideLoading() {
			this.isLoading = false;
		},
		gotoStep5(pageLocation) {
			this.trackAll("Client: Click Checkout 2", {
				page_location: pageLocation
			});

			this.$router.push({
				name: "step5",
				query: {
					price: this.price,
					draft: this.draft
				}
			});
		},
		setLocalStorageVuex() {
			window.localStorage.setItem(
				"vuex-build",
				JSON.stringify(this.activeBuild)
			);
		},
		updateBuildInDatabase() {
			axios({
				url: `/users/0/letsbld-drafts/${this.draftId}?session=${window.CONFIG.SESSION}`,
				method: "PUT"
			});
		},
		duplicateBuild() {
			this.changeShowLoadingOverlay(true);
			axios({
				url: `/drafts/${this.draftId}/influencer`,
				method: "POST",
				responseType: "json"
			})
				.then(response => {
					this.draft = response.data;
					this.$store.dispatch("changeUserDraftId", this.draft);
					window.localStorage.setItem("session-draft", this.draft);
					window.localStorage.setItem("session-price", this.price);
					window.history.pushState(
						{},
						"",
						`/bld/step4?price=${this.price}&draft=${this.draft}`
					);
					this.getSessionData();
				})
				.catch(() => this.changeShowLoadingOverlay(false));
		}
	}
};
</script>

<style scoped lang="scss">
@import "~@s/_asset-mixers.scss";
.step4-mobile-container {
	a[data-toggle="tab"] {
		color: white !important;
	}

	.toggle-menu-btn {
		&.btn {
			&.btn-green {
				&:hover,
				&:focus {
					color: #000 !important;
				}
			}
		}
	}
}

.ico-link {
	display: flex;
}

.ico-streaming {
	h3 {
		float: none;
		margin-top: 10px;
	}

	img {
		margin-top: 0;
	}
}

.overview-overlay .fps-graphing {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	flex-wrap: wrap;
}

.overview-overlay .fps-graphing .fps-graphing-item {
	width: calc(100% / 3);
	text-align: center;
	margin-bottom: 0;
}

.text-white.screen-resolution-text {
	margin: 0;
}

.overview-overlay .fps-graphing .fps-graphing-item .vsync {
	font-size: 14px;
	font-family: "Akkurat-Normal";
}

.row.build-content {
	max-height: 520px;
	overflow-y: scroll;
}

.overview-overlay.for-mobile {
	max-height: 611px;
	margin-top: 0;

	@media (min-height: 611px) {
		max-height: initial;
	}
}

.main-logo img {
	margin-top: 6px;
}

.color-text-disabled {
	display: none;
}

.color-text-indicator-active {
	display: block;
	color: $orchid;
	font-size: 12px;
	position: absolute;
	top: 53px;
	width: 100%;
	right: 3px;
}

.tab-title {
	margin-bottom: 31px !important;
}

.checkout-button {
	padding-right: 24px !important;
	padding-left: 24px !important;
}
</style>